'use client'

import HumanCheck from '@/components/turnstile/HumanCheck'
import LineFetchGuard from '@/components/public/LineFetchGuard'

/**
 * Storefront-wide protections, mounted once by the public and embed layouts:
 * the Turnstile human check (lib/security/human-check) and the redirect to
 * the on-sale line when the app asks for a pass (lib/onsale-line/gate).
 */
export default function SiteGuards() {
  return (
    <>
      <HumanCheck />
      <LineFetchGuard />
    </>
  )
}
